import axios from 'axios';

export const getAll = () => axios.get(`/public/organisations/`);
